import { FunctionalComponent, h } from 'preact';
import { Headline } from './TocPropsTypes';

export const TocDesktopHeadline: FunctionalComponent<Headline> = ({ label, level }) => {
	return <h2 className="SP-TocDesktop__headline">{label}</h2>;
};
